import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  // Add your custom theme configurations here
});

export default theme;
